import React, { useState } from "react";
import styles from "./I&M.module.css";
import TopTabComponent from "../../../../../../components/TopTabComponent/TopTabComponent";
import TextComponent from "../../../../../../components/textComponent/TextComponent";
import { Table } from "antd";
import { ReactComponent as StarIcon } from "../../../../../../assets/images/startIcon.svg";
import { ReactComponent as ActionIcon } from "../../../../../../assets/images/actionicon.svg";



const IngredientsMaterial = () => {
    const options = [
        { id: 1, name: "Ingredients" },
        { id: 2, name: "Materials" },
    ];
    const [focusedTab, setFocusedTab] = useState(options[0]);

    const Data1 = {
        "Batch Quantity": "332.36",
        "Cost per Batch ": "$ 332.36",
        "Scaling Station": "Mixing",
    };

        const Data2 = {
        "Batch Quantity": "332.36",
        "Cost per Batch ": "$ 332.36",
        "Scaling Station": "Packaging",
    };

    const IngredientsColumns = [
        {
            title: "Ingredients",
            dataIndex: "Ingredients",
            key: "Ingredients",
            render: (text, record) => (
                <div className={styles.ingredientCell}>
                    <span>{text}</span>
                    {(record.Ingredients === "Flour, AP KA" ||
                        record.Ingredients === "Sea Salt, fine" ||
                        record.Ingredients === "butter, unsalted") && (
                            <div className={styles.ingredientCellIconsDiv}>
                                <ActionIcon className={styles.icons} />
                                <StarIcon className={styles.icons} />
                            </div>
                        )}
                </div>
            ),
        },
        {
            title: "Quantity",
            dataIndex: "Quantity",
            key: "Quantity",
        },
        {
            title: "Total Baker’s %",
            key: "TotalBakers",
            dataIndex: "TotalBakers",
        },


    ];

    const IngredientsData = [
        {
            Ingredients: "Flour, AP KA",
            Quantity: "100.00",
            TotalBakers: "100",
        },
        {
            Ingredients: "Baking Soda",
            Quantity: "0.81",
            TotalBakers: "0.81",
        },
        {
            Ingredients: "Sea Salt, fine",
            Quantity: "1.71",
            TotalBakers: "1.71",
        },
        {
            Ingredients: "butter, unsalted",
            Quantity: "47.62",
            TotalBakers: "47.62",
        },
        {
            Ingredients: "Brown Sugar ",
            Quantity: "42.86",
            TotalBakers: "42.86",
        },

    ];
    const MaterialsColumns = [
        {
            title: "Materials",
            dataIndex: "Materials",
            key: "Materials",
            render: (text, record) => (
                <div className={styles.ingredientCell}>
                    <span>{text}</span>
                    {(record.Materials === "Flour, AP KA" ||
                        record.Materials === "Sea Salt, fine" ||
                        record.Materials === "butter, unsalted") && (
                            <div className={styles.ingredientCellIconsDiv}>
                                {/* <ActionIcon className={styles.icons} /> */}
                                <StarIcon className={styles.icons} />
                            </div>
                        )}
                </div>
            ),
        },
        {
            title: "Quantity",
            dataIndex: "Quantity",
            key: "Quantity",
        },
        // {
        //     title: "Total Baker’s %",
        //     key: "TotalBakers",
        //     dataIndex: "TotalBakers",
        // },


    ];

    const MaterialsData = [
        {
            Materials: "Flour, AP KA",
            Quantity: "100.00",
        },
        {
            Materials: "Baking Soda",
            Quantity: "0.81",
        },
        {
            Materials: "Sea Salt, fine",
            Quantity: "1.71",
        },
        {
            Materials: "butter, unsalted",
            Quantity: "47.62",
        },
        {
            Materials: "Brown Sugar ",
            Quantity: "42.86",
        },

    ];

    return (
        <div className={styles.mainCont}>
            <div className={styles.toptabComp}>
                <TopTabComponent
                    options={options}
                    focused={focusedTab}
                    setFocused={setFocusedTab}
                    TopTabListStyle={styles.TopTabListStyle}
                    TopTabListContainerStyle={styles.TopTabListContainerStyle}
                />
            </div>

            {focusedTab?.name === options[0]?.name ?
                <>
                    <div className={styles.itemsList}>
                        {Object.entries(Data1).map(([label, value]) => {
                            const formattedLabel = label.replace(/_/g, " ");
                            return (
                                <div className={styles.row}>
                                    <TextComponent className={styles.label} text={`${formattedLabel} :`} />
                                    <TextComponent className={styles.value} text={value || "-"} />

                                </div>
                            );
                        })}
                    </div>
                    <div className={styles.TableDiv}>
                        <Table
                            scroll={{ x: true }}
                            columns={IngredientsColumns}
                            dataSource={IngredientsData}
                            pagination={false}
                        />
                    </div>
                </>
                :
                focusedTab?.name === options[1]?.name ?
                    <>
                        <div className={styles.itemsList}>
                            {Object.entries(Data2).map(([label, value]) => {
                                const formattedLabel = label.replace(/_/g, " ");
                                return (
                                    <div className={styles.row}>
                                        <TextComponent className={styles.label} text={`${formattedLabel} :`} />
                                        <TextComponent className={styles.value} text={value || "-"} />

                                    </div>
                                );
                            })}
                        </div>
                        <div className={styles.TableDiv}>
                            <Table
                                scroll={{ x: true }}
                                columns={MaterialsColumns}
                                dataSource={MaterialsData}
                                pagination={false}
                            />
                        </div>
                    </>
                    : null
            }






        </div>
    );
};

export default IngredientsMaterial;
